export default __webpack_public_path__ + "static/media/et.c853e8ab.svg";